import { lazy } from 'react'

export const GainWeightMenopause = lazy(() => import('./GainWeightMenopause'))
